//@ts-nocheck
/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * MetaIS Enums Repo
 * OpenAPI spec version: latest
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { useCallback } from 'react'
import { useEnumsRepoSwaggerClient } from '../hooks/useEnumsRepoSwaggerClient'
export type ListValidEnumsWithValueParams = {
    value: string
    description: string
}

export type GetValidEnumParams = {
    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    sort?: string[]
}

export interface EnumTypePreview {
    category?: string
    code?: string
    description?: string
    id?: number
    name?: string
    valid?: boolean
    version?: string
}

export interface EnumTypePreviewList {
    results?: EnumTypePreview[]
}

export interface EnumItem {
    code?: string
    description?: string
    engDescription?: string
    engValue?: string
    id?: number
    orderList?: number
    qualifierKey?: string
    qualifierName?: string
    qualifierNameEng?: string
    valid?: boolean
    value?: string
}

export interface EnumType {
    category?: string
    code?: string
    description?: string
    enumItems?: EnumItem[]
    id?: number
    name?: string
    valid?: boolean
}

export type ApiErrorData = { [key: string]: unknown }

export interface ApiError {
    data?: ApiErrorData
    logToken?: string
    message?: string
    type?: string
    values?: string[]
}

type AwaitedInput<T> = PromiseLike<T> | T

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never

export const useUpdateEnumTypeHook = () => {
    const updateEnumType = useEnumsRepoSwaggerClient<void>()

    return useCallback(
        (enumType: EnumType) => {
            return updateEnumType({ url: `/enums/enum`, method: 'PUT', headers: { 'Content-Type': 'application/json' }, data: enumType })
        },
        [updateEnumType],
    )
}

export const useUpdateEnumTypeMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateEnumTypeHook>>>, TError, { data: EnumType }, TContext>
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateEnumTypeHook>>>, TError, { data: EnumType }, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const updateEnumType = useUpdateEnumTypeHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateEnumTypeHook>>>, { data: EnumType }> = (props) => {
        const { data } = props ?? {}

        return updateEnumType(data)
    }

    return { mutationFn, ...mutationOptions }
}

export type UpdateEnumTypeMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateEnumTypeHook>>>>
export type UpdateEnumTypeMutationBody = EnumType
export type UpdateEnumTypeMutationError = ApiError

export const useUpdateEnumType = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateEnumTypeHook>>>, TError, { data: EnumType }, TContext>
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useUpdateEnumTypeHook>>>, TError, { data: EnumType }, TContext> => {
    const mutationOptions = useUpdateEnumTypeMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useInsertEnumTypeHook = () => {
    const insertEnumType = useEnumsRepoSwaggerClient<void>()

    return useCallback(
        (enumType: EnumType) => {
            return insertEnumType({ url: `/enums/enum`, method: 'POST', headers: { 'Content-Type': 'application/json' }, data: enumType })
        },
        [insertEnumType],
    )
}

export const useInsertEnumTypeMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useInsertEnumTypeHook>>>, TError, { data: EnumType }, TContext>
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useInsertEnumTypeHook>>>, TError, { data: EnumType }, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const insertEnumType = useInsertEnumTypeHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useInsertEnumTypeHook>>>, { data: EnumType }> = (props) => {
        const { data } = props ?? {}

        return insertEnumType(data)
    }

    return { mutationFn, ...mutationOptions }
}

export type InsertEnumTypeMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useInsertEnumTypeHook>>>>
export type InsertEnumTypeMutationBody = EnumType
export type InsertEnumTypeMutationError = ApiError

export const useInsertEnumType = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useInsertEnumTypeHook>>>, TError, { data: EnumType }, TContext>
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useInsertEnumTypeHook>>>, TError, { data: EnumType }, TContext> => {
    const mutationOptions = useInsertEnumTypeMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useGetValidEnumHook = () => {
    const getValidEnum = useEnumsRepoSwaggerClient<EnumType>()

    return useCallback(
        (code: string, params?: GetValidEnumParams, signal?: AbortSignal) => {
            return getValidEnum({ url: `/enums/enum/valid/${code}`, method: 'GET', params, signal })
        },
        [getValidEnum],
    )
}

export const getGetValidEnumQueryKey = (code: string, params?: GetValidEnumParams) => {
    return [`/enums/enum/valid/${code}`, ...(params ? [params] : [])] as const
}

export const useGetValidEnumQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetValidEnumHook>>>, TError = ApiError>(
    code: string,
    params?: GetValidEnumParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetValidEnumHook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetValidEnumQueryKey(code, params)

    const getValidEnum = useGetValidEnumHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetValidEnumHook>>>> = ({ signal }) => getValidEnum(code, params, signal)

    return { queryKey, queryFn, enabled: !!code, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetValidEnumHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type GetValidEnumQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetValidEnumHook>>>>
export type GetValidEnumQueryError = ApiError

export function useGetValidEnum<TData = Awaited<ReturnType<ReturnType<typeof useGetValidEnumHook>>>, TError = ApiError>(
    code: string,
    params?: GetValidEnumParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetValidEnumHook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetValidEnumQueryOptions(code, params, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useValidEnumTypeHook = () => {
    const validEnumType = useEnumsRepoSwaggerClient<void>()

    return useCallback(
        (code: string) => {
            return validEnumType({ url: `/enums/enum/valid/${code}`, method: 'PUT' })
        },
        [validEnumType],
    )
}

export const useValidEnumTypeMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useValidEnumTypeHook>>>, TError, { code: string }, TContext>
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useValidEnumTypeHook>>>, TError, { code: string }, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const validEnumType = useValidEnumTypeHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useValidEnumTypeHook>>>, { code: string }> = (props) => {
        const { code } = props ?? {}

        return validEnumType(code)
    }

    return { mutationFn, ...mutationOptions }
}

export type ValidEnumTypeMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useValidEnumTypeHook>>>>

export type ValidEnumTypeMutationError = ApiError

export const useValidEnumType = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useValidEnumTypeHook>>>, TError, { code: string }, TContext>
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useValidEnumTypeHook>>>, TError, { code: string }, TContext> => {
    const mutationOptions = useValidEnumTypeMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useUpdateEnumItemHook = () => {
    const updateEnumItem = useEnumsRepoSwaggerClient<void>()

    return useCallback(
        (enumItem: EnumItem) => {
            return updateEnumItem({ url: `/enumitems/enumitem`, method: 'PUT', headers: { 'Content-Type': 'application/json' }, data: enumItem })
        },
        [updateEnumItem],
    )
}

export const useUpdateEnumItemMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateEnumItemHook>>>, TError, { data: EnumItem }, TContext>
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateEnumItemHook>>>, TError, { data: EnumItem }, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const updateEnumItem = useUpdateEnumItemHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateEnumItemHook>>>, { data: EnumItem }> = (props) => {
        const { data } = props ?? {}

        return updateEnumItem(data)
    }

    return { mutationFn, ...mutationOptions }
}

export type UpdateEnumItemMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateEnumItemHook>>>>
export type UpdateEnumItemMutationBody = EnumItem
export type UpdateEnumItemMutationError = ApiError

export const useUpdateEnumItem = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateEnumItemHook>>>, TError, { data: EnumItem }, TContext>
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useUpdateEnumItemHook>>>, TError, { data: EnumItem }, TContext> => {
    const mutationOptions = useUpdateEnumItemMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useValidEnumItemHook = () => {
    const validEnumItem = useEnumsRepoSwaggerClient<void>()

    return useCallback(
        (code: string) => {
            return validEnumItem({ url: `/enumitems/enumitem/valid/${code}`, method: 'PUT' })
        },
        [validEnumItem],
    )
}

export const useValidEnumItemMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useValidEnumItemHook>>>, TError, { code: string }, TContext>
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useValidEnumItemHook>>>, TError, { code: string }, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const validEnumItem = useValidEnumItemHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useValidEnumItemHook>>>, { code: string }> = (props) => {
        const { code } = props ?? {}

        return validEnumItem(code)
    }

    return { mutationFn, ...mutationOptions }
}

export type ValidEnumItemMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useValidEnumItemHook>>>>

export type ValidEnumItemMutationError = ApiError

export const useValidEnumItem = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useValidEnumItemHook>>>, TError, { code: string }, TContext>
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useValidEnumItemHook>>>, TError, { code: string }, TContext> => {
    const mutationOptions = useValidEnumItemMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useInsertEnumItemHook = () => {
    const insertEnumItem = useEnumsRepoSwaggerClient<void>()

    return useCallback(
        (codeEnumType: string, enumItem: EnumItem) => {
            return insertEnumItem({
                url: `/enumitems/enumitem/${codeEnumType}`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: enumItem,
            })
        },
        [insertEnumItem],
    )
}

export const useInsertEnumItemMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useInsertEnumItemHook>>>,
        TError,
        { codeEnumType: string; data: EnumItem },
        TContext
    >
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useInsertEnumItemHook>>>, TError, { codeEnumType: string; data: EnumItem }, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const insertEnumItem = useInsertEnumItemHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useInsertEnumItemHook>>>, { codeEnumType: string; data: EnumItem }> = (
        props,
    ) => {
        const { codeEnumType, data } = props ?? {}

        return insertEnumItem(codeEnumType, data)
    }

    return { mutationFn, ...mutationOptions }
}

export type InsertEnumItemMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useInsertEnumItemHook>>>>
export type InsertEnumItemMutationBody = EnumItem
export type InsertEnumItemMutationError = ApiError

export const useInsertEnumItem = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useInsertEnumItemHook>>>,
        TError,
        { codeEnumType: string; data: EnumItem },
        TContext
    >
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useInsertEnumItemHook>>>, TError, { codeEnumType: string; data: EnumItem }, TContext> => {
    const mutationOptions = useInsertEnumItemMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useGetJobListHook = () => {
    const getJobList = useEnumsRepoSwaggerClient<string[]>()

    return useCallback(
        (signal?: AbortSignal) => {
            return getJobList({ url: `/scheduler/jobList`, method: 'GET', signal })
        },
        [getJobList],
    )
}

export const getGetJobListQueryKey = () => {
    return [`/scheduler/jobList`] as const
}

export const useGetJobListQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetJobListHook>>>, TError = ApiError>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobListHook>>>, TError, TData>
}) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetJobListQueryKey()

    const getJobList = useGetJobListHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetJobListHook>>>> = ({ signal }) => getJobList(signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobListHook>>>, TError, TData> & {
        queryKey: QueryKey
    }
}

export type GetJobListQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetJobListHook>>>>
export type GetJobListQueryError = ApiError

export function useGetJobList<TData = Awaited<ReturnType<ReturnType<typeof useGetJobListHook>>>, TError = ApiError>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetJobListHook>>>, TError, TData>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetJobListQueryOptions(options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useFireJobNowHook = () => {
    const fireJobNow = useEnumsRepoSwaggerClient<boolean>()

    return useCallback(
        (jobName: string, signal?: AbortSignal) => {
            return fireJobNow({ url: `/scheduler/fire/${jobName}`, method: 'GET', signal })
        },
        [fireJobNow],
    )
}

export const getFireJobNowQueryKey = (jobName: string) => {
    return [`/scheduler/fire/${jobName}`] as const
}

export const useFireJobNowQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useFireJobNowHook>>>, TError = ApiError>(
    jobName: string,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFireJobNowHook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getFireJobNowQueryKey(jobName)

    const fireJobNow = useFireJobNowHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useFireJobNowHook>>>> = ({ signal }) => fireJobNow(jobName, signal)

    return { queryKey, queryFn, enabled: !!jobName, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useFireJobNowHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type FireJobNowQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useFireJobNowHook>>>>
export type FireJobNowQueryError = ApiError

export function useFireJobNow<TData = Awaited<ReturnType<ReturnType<typeof useFireJobNowHook>>>, TError = ApiError>(
    jobName: string,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFireJobNowHook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useFireJobNowQueryOptions(jobName, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useListEnumsHook = () => {
    const listEnums = useEnumsRepoSwaggerClient<EnumTypePreviewList>()

    return useCallback(
        (signal?: AbortSignal) => {
            return listEnums({ url: `/enums/list`, method: 'GET', signal })
        },
        [listEnums],
    )
}

export const getListEnumsQueryKey = () => {
    return [`/enums/list`] as const
}

export const useListEnumsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useListEnumsHook>>>, TError = ApiError>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListEnumsHook>>>, TError, TData>
}) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getListEnumsQueryKey()

    const listEnums = useListEnumsHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListEnumsHook>>>> = ({ signal }) => listEnums(signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListEnumsHook>>>, TError, TData> & {
        queryKey: QueryKey
    }
}

export type ListEnumsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListEnumsHook>>>>
export type ListEnumsQueryError = ApiError

export function useListEnums<TData = Awaited<ReturnType<ReturnType<typeof useListEnumsHook>>>, TError = ApiError>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListEnumsHook>>>, TError, TData>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useListEnumsQueryOptions(options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useListLicenseEnumsHook = () => {
    const listLicenseEnums = useEnumsRepoSwaggerClient<EnumTypePreviewList>()

    return useCallback(
        (signal?: AbortSignal) => {
            return listLicenseEnums({ url: `/enums/list/license`, method: 'GET', signal })
        },
        [listLicenseEnums],
    )
}

export const getListLicenseEnumsQueryKey = () => {
    return [`/enums/list/license`] as const
}

export const useListLicenseEnumsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListLicenseEnumsHook>>>,
    TError = ApiError,
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListLicenseEnumsHook>>>, TError, TData>
}) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getListLicenseEnumsQueryKey()

    const listLicenseEnums = useListLicenseEnumsHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListLicenseEnumsHook>>>> = ({ signal }) => listLicenseEnums(signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListLicenseEnumsHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type ListLicenseEnumsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListLicenseEnumsHook>>>>
export type ListLicenseEnumsQueryError = ApiError

export function useListLicenseEnums<TData = Awaited<ReturnType<ReturnType<typeof useListLicenseEnumsHook>>>, TError = ApiError>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListLicenseEnumsHook>>>, TError, TData>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useListLicenseEnumsQueryOptions(options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useListValidEnumsHook = () => {
    const listValidEnums = useEnumsRepoSwaggerClient<EnumTypePreviewList>()

    return useCallback(
        (signal?: AbortSignal) => {
            return listValidEnums({ url: `/enums/list/all`, method: 'GET', signal })
        },
        [listValidEnums],
    )
}

export const getListValidEnumsQueryKey = () => {
    return [`/enums/list/all`] as const
}

export const useListValidEnumsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useListValidEnumsHook>>>, TError = ApiError>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListValidEnumsHook>>>, TError, TData>
}) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getListValidEnumsQueryKey()

    const listValidEnums = useListValidEnumsHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListValidEnumsHook>>>> = ({ signal }) => listValidEnums(signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListValidEnumsHook>>>, TError, TData> & {
        queryKey: QueryKey
    }
}

export type ListValidEnumsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListValidEnumsHook>>>>
export type ListValidEnumsQueryError = ApiError

export function useListValidEnums<TData = Awaited<ReturnType<ReturnType<typeof useListValidEnumsHook>>>, TError = ApiError>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListValidEnumsHook>>>, TError, TData>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useListValidEnumsQueryOptions(options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useListValidEnumsWithValueHook = () => {
    const listValidEnumsWithValue = useEnumsRepoSwaggerClient<EnumTypePreviewList>()

    return useCallback(
        (params: ListValidEnumsWithValueParams, signal?: AbortSignal) => {
            return listValidEnumsWithValue({ url: `/enums/list/allWithValue`, method: 'GET', params, signal })
        },
        [listValidEnumsWithValue],
    )
}

export const getListValidEnumsWithValueQueryKey = (params: ListValidEnumsWithValueParams) => {
    return [`/enums/list/allWithValue`, ...(params ? [params] : [])] as const
}

export const useListValidEnumsWithValueQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListValidEnumsWithValueHook>>>,
    TError = ApiError,
>(
    params: ListValidEnumsWithValueParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListValidEnumsWithValueHook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getListValidEnumsWithValueQueryKey(params)

    const listValidEnumsWithValue = useListValidEnumsWithValueHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListValidEnumsWithValueHook>>>> = ({ signal }) =>
        listValidEnumsWithValue(params, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListValidEnumsWithValueHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type ListValidEnumsWithValueQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListValidEnumsWithValueHook>>>>
export type ListValidEnumsWithValueQueryError = ApiError

export function useListValidEnumsWithValue<TData = Awaited<ReturnType<ReturnType<typeof useListValidEnumsWithValueHook>>>, TError = ApiError>(
    params: ListValidEnumsWithValueParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListValidEnumsWithValueHook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useListValidEnumsWithValueQueryOptions(params, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useGetEnumHook = () => {
    const getEnum = useEnumsRepoSwaggerClient<EnumType>()

    return useCallback(
        (code: string, signal?: AbortSignal) => {
            return getEnum({ url: `/enums/enum/all/${code}`, method: 'GET', signal })
        },
        [getEnum],
    )
}

export const getGetEnumQueryKey = (code: string) => {
    return [`/enums/enum/all/${code}`] as const
}

export const useGetEnumQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetEnumHook>>>, TError = ApiError>(
    code: string,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEnumHook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetEnumQueryKey(code)

    const getEnum = useGetEnumHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetEnumHook>>>> = ({ signal }) => getEnum(code, signal)

    return { queryKey, queryFn, enabled: !!code, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetEnumHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type GetEnumQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetEnumHook>>>>
export type GetEnumQueryError = ApiError

export function useGetEnum<TData = Awaited<ReturnType<ReturnType<typeof useGetEnumHook>>>, TError = ApiError>(
    code: string,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEnumHook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetEnumQueryOptions(code, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useDeleteEnumTypeHook = () => {
    const deleteEnumType = useEnumsRepoSwaggerClient<void>()

    return useCallback(
        (code: string) => {
            return deleteEnumType({ url: `/enums/enum/${code}`, method: 'DELETE' })
        },
        [deleteEnumType],
    )
}

export const useDeleteEnumTypeMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteEnumTypeHook>>>, TError, { code: string }, TContext>
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteEnumTypeHook>>>, TError, { code: string }, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const deleteEnumType = useDeleteEnumTypeHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteEnumTypeHook>>>, { code: string }> = (props) => {
        const { code } = props ?? {}

        return deleteEnumType(code)
    }

    return { mutationFn, ...mutationOptions }
}

export type DeleteEnumTypeMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteEnumTypeHook>>>>

export type DeleteEnumTypeMutationError = ApiError

export const useDeleteEnumType = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteEnumTypeHook>>>, TError, { code: string }, TContext>
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useDeleteEnumTypeHook>>>, TError, { code: string }, TContext> => {
    const mutationOptions = useDeleteEnumTypeMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useDeleteEnumItemHook = () => {
    const deleteEnumItem = useEnumsRepoSwaggerClient<void>()

    return useCallback(
        (code: string) => {
            return deleteEnumItem({ url: `/enumitems/enumitem/${code}`, method: 'DELETE' })
        },
        [deleteEnumItem],
    )
}

export const useDeleteEnumItemMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteEnumItemHook>>>, TError, { code: string }, TContext>
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteEnumItemHook>>>, TError, { code: string }, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const deleteEnumItem = useDeleteEnumItemHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteEnumItemHook>>>, { code: string }> = (props) => {
        const { code } = props ?? {}

        return deleteEnumItem(code)
    }

    return { mutationFn, ...mutationOptions }
}

export type DeleteEnumItemMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteEnumItemHook>>>>

export type DeleteEnumItemMutationError = ApiError

export const useDeleteEnumItem = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteEnumItemHook>>>, TError, { code: string }, TContext>
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useDeleteEnumItemHook>>>, TError, { code: string }, TContext> => {
    const mutationOptions = useDeleteEnumItemMutationOptions(options)

    return useMutation(mutationOptions)
}
